
<template>
    <div class="center examplex">
      <vs-table striped>
        <template #thead>
          <vs-tr>
            <vs-th style="width: 40%">
              Docente
            </vs-th>
            <vs-th style="width: 60%">
              Calificaciones
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in users"
            :data="tr"
            class="divisionLineas"
          >
            <vs-td>
              <p><strong>{{ tr.docente }}</strong></p>
              <p class="mb-0"><small>EMAIL</small></p>
              <p><strong>{{ tr.email_docente }}</strong></p>
              <p class="mb-0"><small>PERIODO</small></p>
              <p><strong>{{ tr.periodo }}</strong></p>
            </vs-td>
            <vs-td>
                <vs-row v-for="(calif, i) in tr.count_calificaciones" :key="i.codigo_sesion_id" :class="tr.count_calificaciones.length > 1 ?'divisionLineas' : ''">
                    <vs-col w="10">
                        <vs-row>
                            <vs-col w="12">
                                <p><strong>{{ calif.codigo_sesion}} </strong> <small><span class="verDetalle" @click="activeCodigos =! activeCodigos, selectInfo = tr, codigo = calif.codigo_sesion" style="border: 1px solid blue;padding: 3px;border-radius: 5px;">VER DETALLE</span></small></p>
                            </vs-col>
                            <vs-col w="6">
                                <p class="mb-0">Faltantes: 
                                <span v-if="calif.calificaciones_faltantes == 0"><strong>{{ calif.calificaciones_faltantes }} de {{ calif.calificaciones_totales}}</strong></span>
                                <md-chip v-if="calif.calificaciones_faltantes > 0" class="mini-chip col-red" ><strong>{{ calif.calificaciones_faltantes }} de {{ calif.calificaciones_totales}}</strong></md-chip></p>
                            </vs-col>
                            <vs-col w="6">
                                <p>Asentadas: 
                                    <span v-if="calif.calificaciones_asentadas == 0"><strong>{{ calif.calificaciones_asentadas }} de {{ calif.calificaciones_totales}}</strong></span>
                                <md-chip v-if="calif.calificaciones_asentadas > 0" class="mini-chip col-green" ><strong>{{ calif.calificaciones_asentadas }} de {{ calif.calificaciones_totales}}</strong></md-chip></p>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col w="2" v-if="calif.calificaciones_faltantes > 0">
                        <vs-button
                            success
                            flat
                            @click="getFechaLimite(calif.codigo_sesion, tr, calif)"
                        >
                            Enviar recordatorio
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vs-td>
          </vs-tr>
        </template>
        <template #notFound>
            No hay información
        </template>
      </vs-table>
        <modal-codigos v-model="activeCodigos" :row="selectInfo" :codigo="codigo"></modal-codigos>
    </div>
</template>
<script>
import ModalCodigos from './modal/codigos-sesion.vue'
import reportes from '../../../../api/requests/reportes.js'
export default {
    props:[
        'users'
    ],
    data:() => ({
        activeCodigos: false,
        selectInfo: [],
        codigo: ''
    }),
    components: {
        ModalCodigos
    },
    methods:{
        async getFechaLimite(codigo, datos, calif){
            try {
                const idCodigo = datos.codigos_sesiones[codigo][0].configuracion_evaluacion_id
                const { data: response } = await reportes.getFechaLimite(idCodigo)
                this.postEnviarCorreoProfesores(response, datos.codigos_sesiones[codigo][0], calif)
            }
            catch(error){
                console.log(error)
            }

        },
        async postEnviarCorreoProfesores(datos, profesorDatos, calif){
            const loading = this.$vs.loading()
            const fechaLimite = datos.fecha_fin_captura + ' ' + datos.hora_fin_captura 
            const params = {
                "institucion_id": datos.institucion_id,
                "ciclo_escolar_id": datos.ciclo_escolar_id,
                "correo_docente": profesorDatos.email_docente,
                "nombre_docente": profesorDatos.docente,
                "nombre_periodo": profesorDatos.periodo,
                "fecha_limite": fechaLimite,
                "materias": [
                    { "materia": calif.codigo_sesion, "alumnos": calif.calificaciones_faltantes },
                ]
            }
            try {
                const response = await reportes.postEnviarCorreoProfesores(params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'El correo se envió con éxito.'
                })
                loading.close()
            }
            catch(error){
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un error',
                    text: 'Favor de contactar al administrador'
                })
            }
            // loading.close()
        }
    }
}
</script>

<style lang="scss"  scoped >
.verDetalle{
    color: blue;
    cursor: pointer;
}
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('yellow', #febf3d, #fff8ec); 
    @include text-colors ('blue', #37aefb, #cfecfe); 
    @include text-colors ('purple', #6F3E90, #E8DAEF); 

}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
}
.divisionLineas:not(:last-child){
    border-bottom: 1px solid #E5E7E9; 
}
.divisionLineas{
    padding: 2% 0;
}


</style>

        